export const POST_EDITPROFILE_DATA = "POST_EDITPROFILE_DATA"
export const POST_EDITPROFILE_DATA_SUCCESS = "POST_EDITPROFILE_DATA_SUCCESS"
export const POST_EDITPROFILE_DATA_FAILURE = "POST_EDITPROFILE_DATA_FAILURE"

export const POST_USERROFILE_DATA = "POST_USERROFILE_DATA"
export const POST_USERROFILE_DATA_SUCCESS = "POST_USERROFILE_DATA_SUCCESS"
export const POST_USERROFILE_DATA_FAILURE = "POST_USERROFILE_DATA_FAILURE"